import { Component, inject, Input } from '@angular/core';
import { SecurityManagerService } from '@core/security-manager/security-manager.service';
import { PatientHealthInformationService } from '@core/patient-health-information/patient-health-information.service';
import { TypedFormGroup } from 'gandalf';
import { EmployeeExternalCredentialsRequest } from '@gandalf/model/employee-external-credentials-request';
import { ReactiveFormsModule } from '@angular/forms';
import { StatusSelectButtonComponent } from 'morgana';
import { ValidationCssDirective } from '@shared/directives/validation/validation-css.directive';
import { ValidationScrollDirective } from '@shared/directives/validation/validation-scroll.directive';

@Component({
	selector: 'pms-external-credentials',
	templateUrl: './external-credentials.component.html',
	styles: [],
	imports: [
		ReactiveFormsModule,
		StatusSelectButtonComponent,
		ValidationCssDirective,
		ValidationScrollDirective,
	],
})
export class ExternalCredentialsComponent {
	private securityManagerService = inject(SecurityManagerService);
	private patientHealthInformationService = inject(PatientHealthInformationService);

	@Input()
	formGroup: TypedFormGroup<EmployeeExternalCredentialsRequest>;

	@Input()
	practiceHasRxntEnabled: boolean;

	rxntStatuses = [
		{label: 'Enabled', value: true},
		{label: 'Disabled', value: false},
	];

	getRxntCredentialFormGroup() {
		return this.formGroup.controls.rxntCredential;
	}

	showRxntCredential() {
		return this.practiceHasRxntEnabled && this.securityManagerService.userIsProvider();
	}

	canToggleRxnt = (enabling: boolean) => {
		return enabling ? this.patientHealthInformationService.isPhiShareAccepted() : Promise.resolve(true);
	};
}
